/** Query keys for Zoho Desk data. The root value 'zoho' is the invalidation convention. */
export const zohoKeys = {
  root: ['zoho'] as const,
  /** The stored configuration; secrets are never in it, only `has*` flags. */
  config: ['zoho', 'config'] as const,
  ticketFields: ['zoho', 'ticket-fields'] as const,
};
